export const STEP_BANK_STATEMENT = { type: 'CREDIT_SENSE', path: 'loan/bank-details', analyticsStepName: 'bank_statement' };
